module.exports = __webpack_public_path__ + "static/media/infoIconbackbtn.8e73c6c1.svg";